import { useEffect, useState } from "react";

/**
 * A hook that returns whether we're currently rendering in a browser or in SSR
 */
const useIsBrowser = () => {
  const [isBrowser, setIsBrowser] = useState(false);

  useEffect(() => {
    setIsBrowser(true);
  }, []);

  return isBrowser;
};

export default useIsBrowser;
